import { render, staticRenderFns } from "./ReservationMail.vue?vue&type=template&id=2f28ee1a"
import script from "./ReservationMail.vue?vue&type=script&lang=js"
export * from "./ReservationMail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports